<template>
  <select
    class="border w-full bg-transparent border-grey300 font-quietSans px-4 py-4 rounded-lg placeholder-grey500 text-base outline-foundationGrey500 focus:border-foundationGrey500"
    name="name"
    id=""
  >
    <slot></slot>
  </select>
</template>

<script>
export default {
  props: ["name"],
};
</script>

<style></style>
